const initState = {
    dashboard: {},
    studios: [
        // {id: 1, studio_name: 'CorePower', studio_location: 'Wilshire'},
        // {id: 2, studio_name: 'CorePower', studio_location: 'Westwood'},
        // {id: 3, studio_name: 'SoulCycle', studio_location: 'Brentwood'},
        // {id: 4, studio_name: 'SoulCycle', studio_location: 'Hollywood'}
    ],
    reviews: []
}
const studioReducer = (state = initState, action) => {
    switch (action.type) {
        case 'GET_STUDIOS':
            // console.log("fetching studios")
            state.studios = action.studios;
            return state;
        case "SET_DASHBOARD_DATA":
            state.dashboard = action.dashboard;
            return state;
        case "SET_REVIEW_DATA":
            state.reviews = action.reviews;
            return state
    }

    return state
}

export default studioReducer;